
const animateBorders = {
    section : document.querySelectorAll('.block-slide-in-content'),

    inViewport( el ){
        const rect = el.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    },
    initAnim( el ){
        const rightEl = el.querySelector('[slide-right]');
        const bottomEl = el.querySelector('[slide-bottom]');

        if( rightEl ){
            const checkIfVisible = this.inViewport( rightEl );

            checkIfVisible ? rightEl.classList.add('animate-line') : false ;
        }

        if( bottomEl ){
            const checkIfVisible = this.inViewport( bottomEl );

            checkIfVisible ? bottomEl.classList.add('animate-line'): false;
        }
    },
    init(){
        if( this.section ){
            [...this.section].forEach( (el, ind ) => {
                 this.initAnim(el);
            });
        }
    }
}

export default animateBorders;